module.exports = __webpack_public_path__ + "img/banner.00ea1c0a.jpg";